import React, {
  useState,
  useContext,
  createContext,
  useEffect,
  useCallback,
} from 'react'
import _ from 'lodash'

import svgbg from '@/components/onepager/patterns/svg_patterns'

// import patterns
// import typography_pattern from '@/public/pattern_svgs/topography.svg'
// import { waves_pattern_svg } from "@/components/onepager/patterns/waves"

//
//  STATE FOR ONEPAGER TEMPLATE ( all the settings of a template )
//

const onepagerTemplateContext = createContext()

export function ProvideOnepagerTemplate({ children }) {
  const props = useProvideOnepagerTemplate()
  return (
    <onepagerTemplateContext.Provider value={props}>
      {children}
    </onepagerTemplateContext.Provider>
  )
}

export const useOnepagerTemplate = () => {
  return useContext(onepagerTemplateContext)
}

function useProvideOnepagerTemplate() {
  // state
  const [data, setData] = useState()
  const [isBuilder, setIsBuilder] = useState(false)
  const [title, setTitle] = useState()
  const [description, setDescription] = useState()
  const [settings, setSettings] = useState()
  const [design, setDesign] = useState()
  const [cssVars, setCssVars] = useState()

  // sync theme_settings CSS Vars
  useEffect(() => {
    if (design) {
      // console.log('reset CSS VARS');
      setCssVars(draft => {
        let cssVars = {
          'overall-bg-color': design.theme_settings.bg_color,
          'header-text-color': design.text_color,
          'header-title-font':
            design.font == 'cera'
              ? "'CeraPro-Black', 'Helvetica Neue', Helvetica, Arial, sans-serif"
              : "'tiempos-black', serif",
          'header-bg-color': design.background.bg_color,
          'header-pattern': design.background.pattern,
          'header-pattern-color': design.background.pattern_color,
          'canvas-border': design.theme_settings.canvas_border,
          'canvas-border-50': '#000',
          'canvas-inner-shadow': design.theme_settings.canvas_inner_shadow,
          'canvas-thickness': design.theme_settings.canvas_thickness,
          'canvas-block-shadow':
            'inset -2px 0 0 var(--canvas-border), inset 0 -2px 0 var(--canvas-border), inset - 1px 0 0 5px var(--canvas - inner - shadow);',
        }

        // check if header is SVG type
        if (design.background.type == 'svg') {
          // cssVars['header-image'] = waves_pattern_svg.replace(
          //   '%%COLOR%%',
          //   design.background.pattern_color
          // )

          cssVars['header-bg-repeat'] = 'repeat'
          cssVars['header-bg-size'] = 'auto'
          cssVars['header-bg-position'] = 'auto'
        } else {
          cssVars['header-image'] = 'url(' + design.background.image + ')'

          cssVars['header-bg-repeat'] = 'no-repeat'
          cssVars['header-bg-size'] = 'cover'
          cssVars['header-bg-position'] = design.background.position
          cssVars['header-bg-opacity'] =
            design.background.image_opacity[0] / 100
        }

        return cssVars
      })
    }
  }, [design])

  // set template info when data is set
  useEffect(() => {
    if (data) {
      // console.log(data);

      setTitle(data.title)
      setDescription(data.description)

      // setting defaults is blank
      if (data.settings) {
        setSettings(data.settings)
      } else {
        // set base settings
        setSettings({
          grid: {
            matrix: '6x6',
          },
          author: {
            name: 'Your name',
            tag: 'Awesome Person',
            photo: '',
            link: '',
            hide: false,
          },
          media: {
            url: '',
            thumbnail: '',
            type: '',
          },
          branding: {
            logo_text: '',
            logo_image: '',
            link: '',
          },
          cta: {
            text: '',
            link: '',
          },
        })
      }

      // setting defaults is blank
      if (data.design) {
        setDesign(data.design)
      } else {
        // set base design
        setDesign({
          layout: 'default',
          font: 'cera',
          text_color: 'black',
          background: {
            bg_color: 'rgba(255, 255, 255, 1)',
            pattern: 'waves',
            pattern_color: 'rgba(0, 0, 0, 0.1)',
            pattern_opacity: [100],
            position: 'center',
            image: '',
            image_opacity: [100],
            type: 'svg',
          },
          theme_settings: {
            bg_color: '#FFCA00FF',
            canvas_border: '#191919FF',
            canvas_inner_shadow: '#FFCA0024',
            canvas_thickness: '2px',
          },
        })
      }
    }
  }, [data])

  return {
    data,
    setData,
    isBuilder,
    setIsBuilder,
    title,
    setTitle,
    description,
    setDescription,
    settings,
    setSettings,
    design,
    setDesign,
    cssVars,
    setCssVars,
  }
}
